export default [
    {
        path: '/faq-sections',
        name: 'faq-sections',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/FaqSections.vue')
    }
]